import React from 'react';

import Routes from './routes';

import { HelmetProvider   } from 'react-helmet-async';

import ThemeCustomization from './themes';
import ScrollTop from './components/ScrollTop';


const App = () => {
    return (
        <HelmetProvider>
        <ThemeCustomization>
            <ScrollTop>
                <Routes />
            </ScrollTop>
        </ThemeCustomization>
        </HelmetProvider>
    );
};

export default App;
